import useEffectOnce from './useEffectOnce';

var useMount = function useMount(fn) {
  useEffectOnce(function () {
    fn();
  });
};

export default useMount;